import React from 'react';
import { InputList } from 'framework/form';
import EducationInput from './EducationInput';
import { Box } from '@mui/material';

const DEFAULT_EDUCATION_VALUE = {
  haveDocument: false,
  document: null,
};

const EducationListInput = (props: any) => {
  return (
    <Box
      sx={{
        '&& .removable-input': {
          display: 'block',
          paddingBottom: '20px',
          borderBottom: '1px solid',
          borderColor: 'background.primary',
          marginBottom: '20px',
          '& .input-list-rm-btn': { margin: '0 0 25px' },
          '& .education-document__wrapper > button:last-child, & .education-list__document-scan .MuiFormControl-root': {
            marginBottom: 0,
          },
        },
        '& .education-document__wrapper > button:last-of-type': { marginBottom: '20px' },
      }}
    >
      <InputList
        addText="Add education"
        deleteText="Delete education"
        inputTemplate={EducationInput}
        defaultValue={DEFAULT_EDUCATION_VALUE}
        shouldUseFlatObject={false}
        simpleLayout={false}
        {...props}
      />
    </Box>
  );
};

export default EducationListInput;
